const environment = {
    // apiUrl: 'https://localhost:44318/api/', // local
    apiUrl: 'https://sundae-api.objective-faraday.119-59-118-127.plesk.page/api/', // VPS
    
}
export default environment